// Page header component — Brand Kit v1.0 (Geist display title, no italic).

import { ReactNode } from 'react';
import { T } from '../theme';

export function PageHeader({ title, subtitle, right }: { title: string; subtitle?: string; right?: ReactNode }) {
  return (
    <div style={pageStyles.header}>
      <div>
        <h1 style={pageStyles.title}>{title}</h1>
        {subtitle && <p style={pageStyles.subtitle}>{subtitle}</p>}
      </div>
      {right && <div>{right}</div>}
    </div>
  );
}

export function StubBanner({ section }: { section: string }) {
  return (
    <div style={pageStyles.stub}>
      <div style={pageStyles.stubLabel}>scaffold</div>
      <div style={pageStyles.stubBody}>
        The <em style={pageStyles.stubEm}>{section}</em> surface is wired to the studio API but currently returns stub data.
        Functional implementation lands in Phase 1–4 of the Echo→Studio migration plan.
      </div>
    </div>
  );
}

const pageStyles: Record<string, React.CSSProperties> = {
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 48,
    paddingBottom: 24,
    borderBottom: `1px solid ${T.rule}`,
    gap: 24,
  },
  title: {
    fontFamily: T.font.display,
    fontWeight: 600,
    fontSize: 36,
    letterSpacing: '-0.025em',
    color: T.ink,
    lineHeight: 1.1,
    marginBottom: 8,
  },
  subtitle: {
    fontFamily: T.font.body,
    fontStyle: 'normal',
    fontSize: 15,
    color: T.inkMute,
    maxWidth: 640,
  },
  stub: {
    border: `1px solid ${T.rule}`,
    padding: '20px 24px',
    background: T.accentSoft,
    marginBottom: 32,
  },
  stubLabel: {
    fontFamily: T.font.mono,
    fontStyle: 'normal',
    fontSize: 11,
    letterSpacing: '0.06em',
    textTransform: 'uppercase' as const,
    color: T.accent,
    marginBottom: 6,
  },
  stubBody: {
    fontSize: 14,
    color: T.inkSoft,
    lineHeight: 1.65,
  },
  stubEm: {
    fontFamily: T.font.mono,
    fontStyle: 'normal',
    color: T.inkSoft,
  },
};
